const initGridFilters = () => {
  const filterBtns = document.querySelectorAll('.careline-product-grid-filters .button');
  const productGridEl = document.querySelectorAll('.careline-product-grid .multicolumn-card');

  if(!filterBtns || !productGridEl) {
    return false;
  }

  const toCamelCase = (str) => {
    return str.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
  }

  const clearGridFilters = () => {
    filterBtns.forEach(btn => {
      btn.classList.remove('active');
    });
  }

  const filterProductGrid = (filter) => {
    productGridEl.forEach(product => {
      product.classList.remove('not-shown');
    });
    if(filter === 'clear'){
      clearGridFilters();
    } else {
      filterBtns.forEach(btn => {
        if(btn.classList.contains('active')) {
          let filterLoop = btn.dataset.filter;
          productGridEl.forEach(product => {
            let camelFilter = toCamelCase(`filter-${filterLoop}`);
            if(product.dataset[camelFilter] != 'true') {
              product.classList.add('not-shown');
            }
          });
        } 
      });
       /*productGridEl.forEach(product => {
        let camelFilter = toCamelCase(`filter-${filter}`);
        if(product.dataset[camelFilter] == 'true') {
          product.classList.remove('not-shown');
        } else {
          product.classList.add('not-shown');
        }
      });*/
    }
  }

  const applyFilters = (event) => {
    if(event.target.classList.contains('active')) {
      event.target.classList.remove('active');
    } else {
      event.target.classList.add('active');
    }
    filterProductGrid(event.target.dataset.filter);
  }

  filterBtns.forEach(btn => {
    btn.addEventListener('click', applyFilters);
  });

  if(window.location.search.indexOf('filter=') > 0) {
    let grid_url = new URL(window.location);
    let grid_url_filter = grid_url.searchParams.get('filter');
    filterBtns.forEach(btn => {
      if(btn.dataset.filter == grid_url_filter) {
        btn.click();
      }
    });
  }
  
}

initGridFilters();